export const EVENTS_OPTIONS = [
	{
		label: 'Page View',
		value: 'PAGE_VIEW',
	},
	{
		label: 'Lead',
		value: 'LEAD',
	},
];
